module.exports = "/packs/001-bea6f72e18d2a1c25a01c8c27e54db88.jpg";